import { StyleSheet, Dimensions } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { defaultNormalTrayHeight } from '../../withTray/withTrayHelper';

const { height, width } = Dimensions.get('window');

export default StyleSheet.create({
  containerStyle: isExpandedTray => ({
    paddingLeft: isExpandedTray ? 0 : 15,
    flex: 1,
  }),
  descriptionContainer: isExpandedTray => ({
    marginLeft: isExpandedTray ? 15 : 0,
    alignSelf: 'flex-start',
    marginTop: 12,
  }),
  descriptionStyle: theme => ({
    color: theme.colors.textColor,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    letterSpacing: 0,
    lineHeight: 30,
  }),
  errorBackground: {
    backgroundColor: Colors.transparent,
    justifyContent: 'center',
    height: defaultNormalTrayHeight * 0.5,
  },
  warningIcon: {
    marginTop: height * 0.07,
    height: height * 0.1,
    width: width * 0.1,
    resizeMode: 'contain',
  },
  errorMessage: theme => ({
    marginTop: -(height * 0.015),
    marginBottom: 0,
    fontSize: 16.6,
    marginHorizontal: width * 0.1,
    color: theme.colors.textColor,
  }),
  buttonContainer: {
    marginTop: height * 0.015,
  },
  buttonText: {
    fontSize: width * 0.04,
  },
  buttonIcon: {
    marginTop: 0,
    width: width * 0.05,
    height: height * 0.03,
    resizeMode: 'contain',
  },
});
